<template>
	<b-modal
		class="delete-modal"
		:visible="show"
		@hide="() => this.$emit('close')"
		@ok="() => $emit('deleteUser')"
		:title="'Are you sure you want to delete?' | translate"
		:ok-title="'Confirm' | translate"
		:cancel-title="'Cancel' | translate"
	/>
</template>

<script>
export default {
	name: 'dashboard-modal-delete',
	props: ['show'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.delete-modal {
	.modal-body {
		display: none;
	}

	.modal-footer {
		justify-content: space-between;
	}
}
</style>
